<div class="popover-container">
    <div class="data-container">
        <div class="data-header">Dwell Time</div>
        <div class="data-value">{{timeInView}}s</div>
    </div>
    <div class="data-container">
        <div class="data-header">Viewability</div>
        <div class="data-value">{{viewability}}%</div>
    </div>
</div>
